import { PaginationRequestType } from '@/entity/common/pagination.types';
import Api from '@/repository/api';
import { AccountHistory, DataEntity } from '@/entity/clients/Accounts/history.types';
import { IClientsAccountHistoryRepository } from './ClientsAccountHistory.types';
import qs from 'qs';

export class ClientsAccountHistoryRepository implements IClientsAccountHistoryRepository {
    async fetchAll(data?: FormData): Promise<AccountHistory> {
        const response = await Api.get(`/clients/account/get_history`, {
            params: data,
            paramsSerializer: function paramsSerializer(params) {
                return new URLSearchParams(params).toString();
            },
        });
        return response.data as AccountHistory;
    }
    async fetchData(data: PaginationRequestType): Promise<DataEntity> {
        const response = await Api.get(`/clients/account/get_history`, {
            params: data,
            paramsSerializer: function paramsSerializer(params) {
                return qs.stringify(params, { arrayFormat: 'repeat' });
            },
        });
        return response.data as DataEntity;
    }
}
